import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useFullCrmAccess = () => {
  return useQuery({
    queryKey: ["full-crm-access"],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return false;

      console.log("🔍 Full CRM Access Check for user:", session.user.id);

      const { data: role, error } = await supabase.rpc('get_user_role', {
        user_id: session.user.id
      });

      if (error) {
        console.error("❌ Error getting user role:", error);
        return false;
      }

      console.log("✅ User role:", role);
      
      // Allow superusers and internal staff full CRM access
      const hasAccess = role === 'superuser' || role === 'internal_staff';
      console.log("🔑 Full CRM Access granted:", hasAccess);
      
      return hasAccess;
    }
  });
};